<template>
    <v-sheet
        id="step-summary"
        class="pa-6"
    >
        <v-stepper
            v-model="stepper"
            alt-labels
            class="elevation-0 ma-n4"
            :ripple="false"
        >
            <StepSummaryItems
                v-if="steps"
                :currentStep="currentStep"
                :steps="steps"
            />
        </v-stepper>
    </v-sheet>
</template>

<script>
    import StepSummaryItems from '@/components/myHabiteoStudio/components/StepSummaryItems';

    export default {
        name: 'StepsSummary',
        components: {
            StepSummaryItems
        },
        props: {
            currentStep: {
                type: Number,
                required: true
            },
            steps: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                stepper: 1
            }
        },
        watch: {
            stepper(step) {
                this.$emit('select-step', step);
            },
            currentStep(step) {
                this.stepper = step;
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/components/StepSummary.vue